import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

const ReusableDialog = ({ open, handleClose, title, children, actions }) => {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="dialog-title"
            fullWidth
            maxWidth="md"
            PaperProps={{ sx: { minHeight: {md: '60vh', xs: 'auto'} } }}
        >
            <DialogTitle id="dialog-title" sx={{ fontSize: '2rem', fontWeight: 'bold', pt: 2.5, pb: 1 }}>
                {title}
            </DialogTitle>
            <DialogContent dividers sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 2 }}>
                {children}
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                {actions.map((action, index) => (
                    <Button
                        key={index}
                        onClick={action.handler}
                        color={action.color}
                        variant="outlined"
                        size="large"
                        disabled={action.disabled}
                        sx={{ fontSize: '1.5rem', px: 4, py: 1.5 }}
                    >
                        {action.label}
                    </Button>
                ))}
            </DialogActions>
        </Dialog>
    );
};

ReusableDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    actions: PropTypes.arrayOf(
        PropTypes.shape({
            handler: PropTypes.func.isRequired,
            color: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            disabled: PropTypes.bool,
        })
    ).isRequired,
};

export default ReusableDialog;